// TODO, DEPRECATED, remove!!!!!
import classNames from 'classnames';
import * as React from 'react';
import shortid from 'shortid';

import { SelectField } from 'components/Fields/SelectField';

type Value = nil | number | string;

type Props = {
  name: string;
  value: Value;
  label: string;
  applyFilter: (
    arg0: {
      [K in string]: Value;
    },
  ) => void;
  options: Array<SelectOption>;
};

type State = {
  value: Value;
};

class SelectFilter extends React.Component<Props, State> {
  id: string;

  state: State = {
    value: '',
  };

  constructor(props: Props) {
    super(props);
    this.id = shortid();
    this.state = {
      value: props.value,
    };
  }

  onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    this.setState({
      value,
    });
  };

  applyFilter = () => {
    this.props.applyFilter({ [this.props.name]: this.state.value });
  };

  clear = () => {
    this.setState({
      value: null,
    });
  };

  render() {
    const { name, options, label } = this.props;
    const { value } = this.state;
    return (
      <div className='filter-container'>
        <div className='form-group'>
          <SelectField
            id={this.id}
            label={label}
            value={`${!!value ? value : ''}`}
            errors={[]}
            name={name}
            onChange={this.onChange}
            options={options}
          />
        </div>
        <div className='filter-control'>
          <span className={classNames('clear', { hidden: !value })} onClick={this.clear}>
            Clear
          </span>
          <span className='apply' onClick={this.applyFilter}>
            Apply
          </span>
        </div>
      </div>
    );
  }
}

export { SelectFilter };
